import { render, staticRenderFns } from "./identify-code.vue?vue&type=template&id=79aa7567&scoped=true"
import script from "./identify-code.vue?vue&type=script&lang=js"
export * from "./identify-code.vue?vue&type=script&lang=js"
import style0 from "./identify-code.vue?vue&type=style&index=0&id=79aa7567&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aa7567",
  null
  
)

export default component.exports